'use client';

import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { ActionPageProvider } from '@/components/page/action-page-provider';
import { AnalyticsUserTracker } from '@/components/analytics/analytics-user-tracker';
import FeedbackButton from '@/components/ui/treina/FeedbackButton';
import Navbar from '@/components/ui/treina/Navbar';
import Sidebar from '@/components/ui/treina/Sidebar';
import { UserProvider } from '@/components/user/user-provider';
import { MainCoachProvider } from '@/components/user/main-coach-provider';
import { useAuth } from '@/src/hooks/useAuth';
import { useTermsAgreed } from '@/src/hooks/useTermsAgreed';

function PrivateLayoutContent() {
  const { isAuth, isLoading } = useAuth();
  const { hasSigned, isLoading: termsLoading } = useTermsAgreed();
  const location = useLocation();

  if (isLoading || termsLoading) {
    return (
      <div className="flex items-center justify-center min-h-dvh">
        <div className="animate-pulse text-muted-foreground">Carregando...</div>
      </div>
    );
  }

  if (!isAuth) {
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }

  if (!hasSigned && !location.pathname.startsWith('/terms/agreement')) {
    return <Navigate to="/terms/agreement" replace />;
  }

  return (
    <UserProvider>
      <MainCoachProvider>
      <AnalyticsUserTracker />
      <ActionPageProvider>
        <div className="relative min-h-dvh bg-background">
          <FeedbackButton />
          <div className="w-full sm:max-w-7xl sm:mx-auto sm:px-5 sm:pt-5 sm:pb-5 lg:px-8 lg:pt-6 lg:pb-6 min-h-dvh">
            <div className="grid grid-cols-1 sm:grid-cols-[auto_1fr] sm:gap-4 min-h-dvh sm:min-h-[calc(100dvh-2rem)]">
              <Sidebar className="hidden sm:block order-1" />
              <main className="order-2 min-w-0 overflow-auto sm:rounded-2xl sm:bg-card/80 sm:border sm:border-border sm:shadow-sm sm:transition-shadow pb-20 sm:pb-0">
                <div className="flex-1 min-h-full sm:py-6 sm:px-6 lg:px-8 pt-4">
                  <Outlet />
                </div>
              </main>
            </div>
          </div>
          <Navbar className="fixed bottom-0 left-0 right-0 sm:hidden z-50" />
        </div>
      </ActionPageProvider>
      </MainCoachProvider>
    </UserProvider>
  );
}

export function PrivateLayout() {
  return <PrivateLayoutContent />;
}
